import * as tslib_1 from "tslib";
import { BaseModel } from '../_base/model.class';
var Balance = /** @class */ (function (_super) {
    tslib_1.__extends(Balance, _super);
    function Balance(_id, number, property, status, invoiceNumber, invoiceFile, detail, detailCopy, discount, total, notes, createdBy, createdAt, updatedBy, updatedAt) {
        var _this = _super.call(this) || this;
        _this._id = _id;
        _this.number = number;
        _this.property = property;
        _this.status = status;
        _this.invoiceNumber = invoiceNumber;
        _this.invoiceFile = invoiceFile;
        _this.detail = detail;
        _this.detailCopy = detailCopy;
        _this.discount = discount;
        _this.total = total;
        _this.notes = notes;
        _this.createdBy = createdBy;
        _this.createdAt = createdAt;
        _this.updatedBy = updatedBy;
        _this.updatedAt = updatedAt;
        _this.setRequiredFields([
            '_id',
            'number',
            'property',
            'status',
            'invoiceNumber',
            'invoiceFile',
            'details',
            'discount',
            'total',
            'createdAt',
            'createdBy',
        ]);
        return _this;
    }
    return Balance;
}(BaseModel));
export { Balance };
